import { GenericService } from "./Generic.service";

export class UserService extends GenericService<string>{

    readonly URI: string = 'Usuario'

    constructor(){
        super();
        this.setUri(this.URI);
    }

    getInfo = async ()=>{
        return super.get() //Teste de API 
    }
    
}